export type FeatureArticleSearchTranslationKeys =
  'ARTICLE_SEARCH_RESULTS_TITLE';
